export const platformAccess = {
  junior: {
    required: [
      { platform: 'AWS Console', access: 'ReadOnly', purpose: 'Infrastructure monitoring', setup: 'Request IAM user with read permissions' },
      { platform: 'GitHub', access: 'Developer', purpose: 'Infrastructure code access', setup: 'Request access to infrastructure repos' },
      { platform: 'Jenkins', access: 'Developer', purpose: 'CI/CD pipeline access', setup: 'Request developer permissions' },
      { platform: 'Slack', access: 'Member', purpose: 'DevOps team communication', setup: 'Join #devops-team, #infrastructure channels' }
    ],
    optional: [
      { platform: 'Datadog', access: 'Viewer', purpose: 'Infrastructure monitoring', setup: 'Request read-only access' },
      { platform: 'Docker Hub', access: 'Developer', purpose: 'Container registry', setup: 'Join organization team' }
    ]
  },
  mid: {
    required: [
      { platform: 'AWS Console', access: 'PowerUser', purpose: 'Infrastructure management', setup: 'Request elevated IAM permissions' },
      { platform: 'Terraform Cloud', access: 'Developer', purpose: 'Infrastructure as code', setup: 'Request workspace access' },
      { platform: 'PagerDuty', access: 'Responder', purpose: 'Incident management', setup: 'Added to on-call rotation' },
      { platform: 'Vault', access: 'Developer', purpose: 'Secret management', setup: 'Request policy assignment' }
    ],
    optional: [
      { platform: 'New Relic', access: 'Developer', purpose: 'Application monitoring', setup: 'Request account access' },
      { platform: 'Grafana', access: 'Editor', purpose: 'Dashboard management', setup: 'Request editor permissions' }
    ]
  },
  senior: {
    required: [
      { platform: 'AWS Console', access: 'Admin', purpose: 'Full infrastructure management', setup: 'Request admin IAM role' },
      { platform: 'Terraform Cloud', access: 'Admin', purpose: 'Infrastructure automation', setup: 'Organization admin permissions' },
      { platform: 'PagerDuty', access: 'Admin', purpose: 'Incident management', setup: 'Admin role for team management' },
      { platform: 'GitHub', access: 'Admin', purpose: 'Repository and team management', setup: 'Admin access to organization' }
    ],
    optional: [
      { platform: 'Splunk', access: 'Admin', purpose: 'Advanced analytics', setup: 'Request admin permissions' },
      { platform: 'Kubernetes Dashboard', access: 'Admin', purpose: 'Cluster management', setup: 'Cluster admin permissions' }
    ]
  }
};
